import { motion } from "framer-motion";
import { HERO_PROOF_POINTS } from "@/data/content";

const ProofPoint = ({ point, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.55, delay: 1 + index * 0.1 }}
    data-testid={`hero-proof-point-${index}`}
    className="min-w-0 flex-1 px-2 text-center sm:px-4 xl:min-w-[118px] xl:flex-none"
  >
    <span data-testid={`hero-proof-point-value-${index}`} className="block font-heading text-xl font-semibold leading-none text-white drop-shadow-sm sm:text-2xl">
      {point.value}
    </span>
    <span className="mt-2 block text-[10px] leading-tight text-white/65 sm:text-xs">{point.label}</span>
  </motion.div>
);

export const HeroStats = () => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, delay: 0.95 }}
    data-testid="hero-stats-row"
    className="mt-7 flex w-full max-w-xl items-center self-end xl:mt-0 xl:w-auto xl:max-w-none"
  >
    {HERO_PROOF_POINTS.map((point, index) => (
      <div key={point.label} className="contents">
        {index > 0 && <span aria-hidden="true" className="h-10 w-px shrink-0 bg-white/25" />}
        <ProofPoint point={point} index={index} />
      </div>
    ))}
  </motion.div>
);
